import { createContext, useContext } from 'react';
import type { PurchaseAttribution } from './purchase-attribution';

/**
 * The picker's attribution, handed to the components that fire `buy_plan` (the plan card and the
 * billing-cycle step) without threading a prop through every layer of `SymphonyPricing`. They cannot
 * read it off the URL themselves: the picker strips `origin` / `feature` from the address bar on mount.
 */
export const PurchaseAttributionContext = createContext<PurchaseAttribution>({});

export const usePurchaseAttribution = (): PurchaseAttribution => useContext(PurchaseAttributionContext);
